import { render, staticRenderFns } from "./RankingMore.vue?vue&type=template&id=b37b743e&scoped=true"
import script from "./RankingMore.vue?vue&type=script&lang=js"
export * from "./RankingMore.vue?vue&type=script&lang=js"
import style0 from "./RankingMore.vue?vue&type=style&index=0&id=b37b743e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37b743e",
  null
  
)

export default component.exports